import React, { useEffect, useState } from "react";
import {
  Card,
  Col,
  Descriptions,
  Image,
  Row,
  Skeleton,
  Space,
  Tag,
  Typography,
} from "antd";
import { Link, useParams } from "react-router-dom";
import axios from "../../../requests/axios";
import routes from "../../../requests/routes";
import classes from "./CapacityProjectPage.module.scss";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedin,
  FaYoutube,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import ClampText from "../../../generic components/TextTruncate/TextTruncate";
const { Title, Paragraph } = Typography;

export default function CapacityProjectPage() {
  const { idOrSlug } = useParams();
  const [loading, setLoading] = useState(false);
  const [project, setProject] = useState(null);
  const [news, setNews] = useState([]);
  const [events, setEvents] = useState([]);

  const load = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(routes.capacityPublicItem(idOrSlug));
      setProject(data?.project || null);
      setNews(data?.news || []);
      setEvents(data?.project.events || []);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    } catch (e) {
      // silent
    } finally {
    }
  };

  useEffect(() => {
    load();
  }, [idOrSlug]);

  if (!project) return null;

  return (
    <div className={classes.project}>
      <div>
        {!loading && project.bannerImage ? (
          <div
            style={{
              height: 400,
              background: `url(${project.bannerImage}) center/cover no-repeat`,
            }}
          />
        ) : (
          <Skeleton.Image
            active
            style={{
              width: "100vw",
              height: 400,
              zIndex: 100,
            }}
          />
        )}
        <div className={classes.project__head}>
          {!loading ? (
            <div className={classes.project__logo}>
              <img src={project.logo} alt={project.name} />
            </div>
          ) : (
            <Skeleton.Image
              active
              shape="round"
              style={{
                width: "calc(120px + 1rem)",
                height: "calc(120px + 1rem)",
                // borderRadius: 12,
                // transform: "translateY(-60px)",
                zIndex: 100,
              }}
            />
          )}
          <div className={classes.project__title}>
            <h2>{project.name}</h2>
            <div style={{ marginBottom: 8 }}>
              {project.programName && <Tag>{project.programName}</Tag>}
              {project.type && <Tag color="blue">{project.type}</Tag>}
            </div>
          </div>
        </div>
      </div>
      <div className={classes.project__container}>
        <div className={classes.project__body}>
          {/* Overview */}
          {loading ? (
            <Skeleton active />
          ) : (
            <div className={classes.project__body__box}>
              <h2 className={classes.project__body__title}>Overview</h2>
              <p
                style={{ lineHeight: 1.7 }}
                dangerouslySetInnerHTML={{ __html: project.overviewHtml }}
              />
            </div>
          )}

          {project.sections &&
            project.sections.length > 0 &&
            project.sections.map((section, index) => (
              <div key={index} className={classes.project__body__box}>
                <h2 className={classes.project__body__title}>
                  {section.title}
                </h2>

                <ClampText lines={5}>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: section.description || "",
                    }}
                  />
                </ClampText>
              </div>
            ))}

          {/* Partners */}
          {Array.isArray(project.partners) && project.partners.length > 0 && (
            <div className={classes.project__body__box}>
              <h2 className={classes.project__body__title}>Partners</h2>

              <div className={classes.project__partners}>
                <div
                  className={classes.project__partners__box}
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "2rem",
                  }}
                >
                  <Image.PreviewGroup>
                    {project.partners.map((p, i) => (
                      <Image
                        width={120}
                        height={120}
                        src={p.logo}
                        key={i}
                        alt={p.name || "Partner"}
                        style={{ objectFit: "contain" }}
                      />
                    ))}
                  </Image.PreviewGroup>
                </div>
              </div>
            </div>
          )}

          {/* News */}
          {news.length > 0 && (
            <>
              <div className={classes.project__body__box}>
                <h2 className={classes.project__body__title}>News</h2>
              </div>
              <div className={classes.project__news}>
                {news.map((n) => (
                  <div className={classes.project__news__box}>
                    <Link
                      to={`/capacity-projects/${
                        project.slug || project._id
                      }/news/${n.slug || n._id}`}
                    >
                      <div className={classes.project__news__box__cover}>
                        {n.coverImage ? (
                          <img
                            src={n.coverImage}
                            alt=""
                            style={{ height: 160, objectFit: "cover" }}
                          />
                        ) : null}
                        <div className={classes.project__news__box__content}>
                          <h2
                            className={
                              classes.project__news__box__content__title
                            }
                          >
                            {n.title}
                          </h2>
                          <ClampText>
                            <p
                              dangerouslySetInnerHTML={{
                                __html: n.summary || "",
                              }}
                            />
                          </ClampText>
                        </div>
                      </div>
                    </Link>
                  </div>
                ))}
              </div>
            </>
          )}
          {events.length > 0 && (
            <>
              <div className={classes.project__body__box}>
                <h2 className={classes.project__body__title}>Events</h2>
              </div>
              <div className={classes.project__news}>
                {events.map((event) => (
                  <div className={classes.project__news__box}>
                    <Link to={`/events/${event.slug || event._id}`}>
                      <div className={classes.project__news__box__cover}>
                        {event.bannerImage ? (
                          <img
                            src={event.bannerImage}
                            alt=""
                            style={{ height: 160, objectFit: "cover" }}
                          />
                        ) : null}
                        <div className={classes.project__news__box__content}>
                          <h2
                            className={
                              classes.project__news__box__content__title
                            }
                          >
                            {event.title}
                          </h2>
                          <ClampText>
                            <p
                              dangerouslySetInnerHTML={{
                                __html: event.summary || "",
                              }}
                            />
                          </ClampText>
                        </div>
                      </div>
                    </Link>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
        <div className={classes.project__sidebar}>
          <div className={classes.project__sidebar__wrapper}>
            <div className={classes.project__sidebar__wrapper__title}>
              <p>Project Details</p>
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <Descriptions column={1} size="small">
                {project.referenceNumber && (
                  <Descriptions.Item label="Reference">
                    {project.referenceNumber}
                  </Descriptions.Item>
                )}
                {project.startDate && (
                  <Descriptions.Item label="Start">
                    {new Date(project.startDate).toLocaleDateString()}
                  </Descriptions.Item>
                )}
                {project.endDate && (
                  <Descriptions.Item label="End">
                    {new Date(project.endDate).toLocaleDateString()}
                  </Descriptions.Item>
                )}
                {project.socials?.website && (
                  <Descriptions.Item label="Website">
                    <a
                      style={{ cursor: "pointer" }}
                      href={project.socials.website}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Click Here
                    </a>
                  </Descriptions.Item>
                )}
              </Descriptions>
            </div>
          </div>

          <div className={classes.project__sidebar__wrapper}>
            <div className={classes.project__sidebar__wrapper__title}>
              <p>Social Networks</p>
            </div>

            <div className={`${classes.socials}`}>
              <ul className={`${classes.socials__grid}`} role="list">
                {project.socials.facebook && (
                  <li
                    className={`${classes.card} ${
                      classes[`card--facebook`] || ""
                    }`}
                  >
                    <a
                      className={`${classes.card__link}`}
                      href={project.socials.facebook}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span
                        className={`${classes.card__badge}`}
                        aria-hidden="true"
                      >
                        <FaFacebookF size={20} />
                      </span>
                      <span className={`${classes.card__name}`}>Facebook</span>
                    </a>
                  </li>
                )}
                {project.socials.instagram && (
                  <li
                    className={`${classes.card} ${
                      classes[`card--instagram`] || ""
                    }`}
                  >
                    <a
                      className={`${classes.card__link}`}
                      href={project.socials.instagram}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span
                        className={`${classes.card__badge}`}
                        aria-hidden="true"
                      >
                        <FaInstagram size={20} />
                      </span>
                      <span className={`${classes.card__name}`}>Instagram</span>
                    </a>
                  </li>
                )}
                {project.socials.linkedin && (
                  <li
                    className={`${classes.card} ${
                      classes[`card--linkedin`] || ""
                    }`}
                  >
                    <a
                      className={`${classes.card__link}`}
                      href={project.socials.linkedin}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span
                        className={`${classes.card__badge}`}
                        aria-hidden="true"
                      >
                        <FaLinkedin size={20} />
                      </span>
                      <span className={`${classes.card__name}`}>LinkedIn</span>
                    </a>
                  </li>
                )}
                {project.socials.x && (
                  <li className={`${classes.card} ${classes[`card--x`] || ""}`}>
                    <a
                      className={`${classes.card__link}`}
                      href={project.socials.x}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span
                        className={`${classes.card__badge}`}
                        aria-hidden="true"
                      >
                        <FaXTwitter size={20} />
                      </span>
                      <span className={`${classes.card__name}`}>
                        X (Twitter)
                      </span>
                    </a>
                  </li>
                )}
                {project.socials.youtube && (
                  <li
                    className={`${classes.card} ${
                      classes[`card--youtube`] || ""
                    }`}
                  >
                    <a
                      className={`${classes.card__link}`}
                      href={project.socials.youtube}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span
                        className={`${classes.card__badge}`}
                        aria-hidden="true"
                      >
                        <FaYoutube size={20} />
                      </span>
                      <span className={`${classes.card__name}`}>Youtube</span>
                    </a>
                  </li>
                )}
              </ul>
            </div>
          </div>
          <div className={classes.project__sidebar__wrapper}>
            <div
              className={classes.project__sidebar__wrapper__title}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <p>{project.program.name}</p>
              {project.program?.logo && (
                <img
                  src={project.program.logo}
                  alt=""
                  style={{ width: 100, height: 60, objectFit: "contain" }}
                />
              )}
            </div>
            {project.program?.description && (
              <ClampText>
                <p
                  dangerouslySetInnerHTML={{
                    __html: project.program.description,
                  }}
                />
              </ClampText>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
